<template>
  <div class="visual">
    <div class="head">
      <h3>视觉交控</h3>
      <span @click="toMore">查看更多</span>
    </div>

    <div class="list">
      <div
        v-for="pic in picList"
        :key="pic.id"
        :style="{ background: `center / cover no-repeat url(${pic.picturePath})` }"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Visual',

  data() {
    return {
      picList: [],
    };
  },

  mounted() {
    this.loadPics();
  },

  methods: {
    /** 加载图片列表 */
    loadPics() {
      const replacement = {
        subjectId: 1,
      };
      Promise.all(
        [7, 8, 9].map((location) =>
          this.$api.getCarouselData(replacement, { location, pageId: 1, pageSize: 10 })
        )
      ).then(([arr1, arr2, arr3]) => {
        this.picList = [...arr1, ...arr2, ...arr3];
      });
    },

    toMore() {
      window.open('https://sjjk.jchc.cn');
    },
  },
};
</script>

<style lang="scss" scoped>
.visual {
  margin-top: 116px;
  padding: 0 40px;

  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 62px;
    h3 {
      font-size: 42px;
      font-weight: 500;
      color: #333333;
      line-height: 59px;
    }
    > span {
      font-size: 26px;
      font-weight: 400;
      color: #adadad;
      line-height: 37px;
    }
  }

  .list {
    margin-top: 62px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 18px;

    > div {
      height: 230px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/Visual.vue